document.addEventListener('Searchanise.Loaded', function() {
  (function($) {
//     $(document).one('Searchanise.ResultsUpdated', function() {
//       window.onpageshow = function(event) {
//         if (event.persisted) {
//           window.location.reload() 
//         }
//       };      
//     });
    
    $(document).on('Searchanise.AddToCartSuccess', function(event, add_to_cart_id, product) {
      BT.runCartAction('open_cart', function() {});
    });
  })(window.Searchanise.$);
});